import { Routes } from "@angular/router";
import { EmptyComponent } from "./pages/empty/empty.component";
import { requireSessionID, requireLogin, refreshCustomerState } from "./auth.gaurd";

export const routes: Routes = [
  {
    path: "box-style/:categoryCode",
    loadComponent: () => import("./pages/box-style/box-style.component").then((m) => m.BoxStyleComponent),
    canActivate: [requireSessionID()],
    data: {
      title: "Box Style",
    },
  },

  {
    path: "box-style/:categoryCode/:uploadDesign",
    loadComponent: () => import("./pages/box-style/box-style.component").then((m) => m.BoxStyleComponent),
    canActivate: [requireSessionID()],
    data: {
      title: "Box Style",
    },
  },

  {
    path: "box-options/:categoryCode/:subcategoryCode/:uploadDesign",
    loadComponent: () => import("./pages/box-options/box-options.component").then((m) => m.BoxOptionsComponent),
    canActivate: [refreshCustomerState(), requireSessionID()],
    data: {
      title: "Box Options",
    },
  },

  {
    path: "box-options",
    loadComponent: () => import("./pages/box-options/box-options.component").then((m) => m.BoxOptionsComponent),
    canActivate: [refreshCustomerState(), requireSessionID()],
    data: {
      title: "Box Options",
    },
  },
  {
    path: "design",
    loadComponent: () => import("./pages/design/design.component").then((m) => m.DesignComponent),
    canActivate: [refreshCustomerState(), requireLogin()],
    data: {
      title: "Design Your Box",
    },
  },
  {
    path: "design-3d",
    loadChildren: () => import("./pages/design-3d.routes").then((m) => m.DESIGN_3D_ROUTES),
  },
  {
    path: "design-services",
    loadComponent: () =>
      import("./pages/design-services/design-services.component").then((m) => m.DesignServicesComponent),
  },
  {
    path: "review-box",
    loadComponent: () => import("./pages/review-box/review-box.component").then((m) => m.ReviewBoxComponent),
    canActivate: [refreshCustomerState(), requireLogin()],
    data: {
      title: "Review & Add to Cart",
    },
  },
  {
    path: "upload-design",
    loadComponent: () => import("./pages/upload-design/upload-design.component").then((m) => m.UploadDesignComponent),
    canActivate: [refreshCustomerState(), requireLogin()],
    data: {
      title: "Upload Design",
    },
  },
  {
    path: "upload-design/:category/:subcategory",
    canActivate: [refreshCustomerState(), requireLogin()],
    loadComponent: () => import("./pages/upload-design/upload-design.component").then((m) => m.UploadDesignComponent),
    data: {
      title: "Upload Design",
    },
  },
  {
    path: "box-edit",
    loadComponent: () => import("./pages/box-edit/box-edit.component").then((m) => m.BoxEditComponent),
    canActivate: [requireLogin()],
    data: {
      title: "Edit Order",
    },
  },
  {
    path: "",
    pathMatch: "full",
    component: EmptyComponent,
    data: {
      title: "Custom Box",
    },
  },
];
